export default {
  role: 'guest',
  user: {},
};
